import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ccBrand } from "@Shared/@Utils/helpers/stripe";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import AddPaymentModal from "./add-payment-modal";
import PaymentDetailsModal from "./payment-details-modal";
import { orderBy } from "lodash";
import { mapActions, mapGetters } from "vuex";
import { DELETE_PAYMENT_METHOD, LOAD_ACCOUNT_PLAN_DETAILS, SET_CARD_AS_DEFAULT } from "../../store/account-plan-actions";
import { PAYMENT_METHODS } from "../../store/account-plan-getters";
import InlinePrompt from "@Shared/components/general/inline-prompt.vue";
import { showToast } from "@Shared/@Utils/constants";
import Amplitude from "@Shared/@Utils/amplitude";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PaymentMethods",
  components: {
    SimpleButton,
    AddPaymentModal,
    PaymentDetailsModal,
    InlinePrompt
  },
  data() {
    return {
      loadingBadge: {},
      deleting: "",
      deletingSucceeded: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("AccountPlanStore", [PAYMENT_METHODS])), {}, {
    noPaymentMethod() {
      return this.PAYMENT_METHODS.length === 0;
    },
    sortedPaymentMethods() {
      return orderBy(this.PAYMENT_METHODS, ["id"], ["desc"]);
    },
    canDelete() {
      return this.PAYMENT_METHODS.length > 1;
    },
    options() {
      return {
        filterable: false,
        sortable: ["expirationDate"],
        columns: ["brand", "number", "expirationDate", "actions"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-up",
          down: "fa-sort-down",
          is: "fa-sort"
        },
        headings: {
          brand: this.$t("account.accountPlan.paymentMethodsTab.brand"),
          number: this.$t("account.accountPlan.paymentMethodsTab.number"),
          expirationDate: this.$t("account.accountPlan.paymentMethodsTab.expirationDate"),
          actions: this.$t("global.words.actions")
        },
        columnsClasses: {
          actions: "hidden-heading"
        },
        skin: "table table-hover",
        perPage: 999999,
        texts: {
          noResults: this.$t("account.accountPlan.noMethodsMessage")
        }
      };
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("AccountPlanStore", [SET_CARD_AS_DEFAULT, DELETE_PAYMENT_METHOD, LOAD_ACCOUNT_PLAN_DETAILS])), {}, {
    mapCCBrandIcon(brand) {
      return ccBrand(brand);
    },
    showAddPaymentModal() {
      this.$refs.addPayment.openModal();
    },
    showPaymentDetailsModal(paymentId) {
      var _context;
      const paymentMethod = _findInstanceProperty(_context = this.sortedPaymentMethods).call(_context, method => method.id == paymentId);
      this.$refs.paymentDetails.openModal({
        paymentId,
        address: paymentMethod.address,
        cardExpYear: paymentMethod.cardExpYear,
        cardExpMonth: paymentMethod.cardExpMonth,
        isEditable: paymentMethod.isEditable
      });
    },
    async setAsDefaultPaymentMethod(paymentId) {
      this.$set(this.loadingBadge, paymentId, true);
      await this.SET_CARD_AS_DEFAULT(paymentId);
      await this.LOAD_ACCOUNT_PLAN_DETAILS();
      this.$set(this.loadingBadge, paymentId, false);
      Amplitude.logEvent("Account Plan - New Payment Method Set as Default", {
        paymentId
      });
    },
    async deletePaymentMethod(paymentId) {
      this.deleting = paymentId;
      const result = await this.DELETE_PAYMENT_METHOD(paymentId);
      if (result.succeeded) {
        await this.LOAD_ACCOUNT_PLAN_DETAILS();
        showToast("success", "paymentMethodDeleted");
      }
      this.deletingSucceeded = result.succeeded;
      this.deleting = null;
      Amplitude.logEvent("Account Plan - Payment Method Delete Attempt Completed", {
        paymentId,
        result
      });
    }
  })
});